import { QUERY_PARAM_KEYS } from 'common/constants';
import type { DfdEmbedUrlOptions } from 'common/dfd-embed-url';
import { getDfdEmbedTarget } from 'common/dfd-flows';
import { useUrlParam } from 'hooks/use-url-param/use-url-param.hook';

/**
 * The TELUS flow or widget the current URL asks for, or an empty target for the
 * default chatbot.
 */
export const useDfdEmbedTarget = (): DfdEmbedUrlOptions => {
  const { urlParam } = useUrlParam(QUERY_PARAM_KEYS.FLOW);

  return getDfdEmbedTarget(urlParam);
};
